import React, { useState } from 'react';
import { Button, FormLabel, MenuItem, TextField } from '@mui/material';
import notify from 'lib/notify';
import { sendApiRequest } from 'lib/api/public';
import Modal from 'components/common/Modal';
import TimezoneSelector from 'components/common/TimezoneSelector';

type Props = {
  onSuccess: () => void;
};

const GoogleSignupDetailsForm = ({ onSuccess }: Props) => {
  const [timezone, setTimezone] = useState(Intl.DateTimeFormat().resolvedOptions().timeZone);
  const [howDidYouHearAboutUs, setHowDidYouHearAboutUs] = useState('');
  const [saving, setSaving] = useState(false);

  const onSave = async () => {
    if (!timezone) {
      notify('Please select a timezone');
      return;
    }

    if (!howDidYouHearAboutUs) {
      notify('Please tell us how you found Harbor');
      return;
    }

    setSaving(true);

    try {
      await sendApiRequest({
        path: '/users/complete-google-signup',
        method: 'POST',
        data: {
          timezone,
          howDidYouHearAboutUs,
        },
      });

      onSuccess();
      notify('Saved');
    } catch (error) {
      notify(error);
    } finally {
      setSaving(false);
    }
  };

  const renderContent = () => (
    <>
      <FormLabel sx={{ color: theme => theme.palette.text.primary, fontWeight: 'bold' }} required>
        Timezone
      </FormLabel>
      <TimezoneSelector timezone={timezone} onChange={setTimezone} />

      <br />
      <br />

      <FormLabel sx={{ color: theme => theme.palette.text.primary, fontWeight: 'bold' }} required>
        How did you find Harbor?
      </FormLabel>
      <TextField
        fullWidth
        select
        size="small"
        value={howDidYouHearAboutUs}
        onChange={e => setHowDidYouHearAboutUs(e.target.value)}
        slotProps={{
          htmlInput: { 'data-testid': '@google-signup-referral-source' },
          select: { labelId: 'google-signup-how-did-you-find-harbor-label' },
        }}
      >
        <MenuItem value="Google Search">Google Search</MenuItem>
        <MenuItem value="LinkedIn">LinkedIn</MenuItem>
        <MenuItem value="Reddit">Reddit</MenuItem>
        <MenuItem value="Facebook">Facebook</MenuItem>
        <MenuItem value="Instagram">Instagram</MenuItem>
        <MenuItem value="Friend/Colleague/Offline">Friend/Colleague/Offline</MenuItem>
        <MenuItem value="Other">Other</MenuItem>
      </TextField>
    </>
  );

  const renderActions = () => (
    <Button variant="contained" color="primary" onClick={onSave} disabled={saving}>
      {saving ? 'Saving...' : 'Save'}
    </Button>
  );

  return (
    <Modal
      open={true}
      hideCloseButton
      title="Complete your signup"
      renderContent={renderContent}
      renderActions={renderActions}
    />
  );
};

export default GoogleSignupDetailsForm;
